import { type IconProps } from '@kijiji/icons/src/components/Icon'
import AutosIcon from '@kijiji/icons/src/icons/Autos'
import CategoriesIcon from '@kijiji/icons/src/icons/Categories'
import ForSaleIcon from '@kijiji/icons/src/icons/ForSale'
import JobsIcon from '@kijiji/icons/src/icons/Jobs'
import PetsIcon from '@kijiji/icons/src/icons/Pets'
import RealEstateIcon from '@kijiji/icons/src/icons/RealEstate'
import ServicesIcon from '@kijiji/icons/src/icons/Services'
import VacationRentalsIcon from '@kijiji/icons/src/icons/VacationRentals'
import { type FC } from 'react'

const CATEGORY_DROPDOWN_ICON_LIST: { [key: string]: FC<IconProps> } = {
  0: CategoriesIcon,
  1: ServicesIcon,
  10: ForSaleIcon,
  27: AutosIcon,
  34: RealEstateIcon,
  45: JobsIcon,
  72: ServicesIcon,
  112: PetsIcon,
  800: VacationRentalsIcon,
}

export const getIconFromCategoryId = (categoryId?: number) => {
  if (!categoryId) {
    const CategoryIcon = CATEGORY_DROPDOWN_ICON_LIST[0]
    return <CategoryIcon aria-hidden />
  }

  let CategoryIcon = CATEGORY_DROPDOWN_ICON_LIST[categoryId]

  /** If categoryId doesn't exist on the list, then return general icon */
  if (!CategoryIcon) {
    CategoryIcon = CATEGORY_DROPDOWN_ICON_LIST[0]
  }

  return <CategoryIcon aria-hidden />
}
